/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async perans() {
    return await http.get(`permission/roles`).then(({ data }) => data);
  },
  async fetch({}, params) {
    let detail;
    try {
      detail = await http.get(`/permission?${queryString(params)}`).then(({ data }) => data);
    } catch (e) {
      detail = null;
    }
    return detail;
  },
  download({}, params) {
    return process.env.VUE_APP_API_URL + `/permission/download?${queryString(params)}`;
  },
  async save({}, payload) {
    return await http.post(`permission`, payload);
  },
};

export default {
  namespaced: true,
  actions,
};
